import { render, staticRenderFns } from "./fJournalVoucher.vue?vue&type=template&id=17a41023"
import script from "./fJournalVoucher.vue?vue&type=script&lang=js"
export * from "./fJournalVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports